import { supabase } from "@/integrations/supabase/client";
import { normalizeEmail } from "@/lib/normalizeEmail";

/**
 * Na e-mailverificatie heeft de client vaak nog geen sessie (signUp levert er geen
 * op zolang de mail niet bevestigd is). Deze helper probeert eerst de bestaande
 * sessie te verversen en logt anders automatisch in met de zojuist gekozen
 * gegevens, zodat de gebruiker direct in het dashboard/onboarding belandt.
 *
 * Veiligheid: het wachtwoord wordt alleen als parameter doorgegeven en nergens
 * bewaard, gelogd of in een foutmelding gezet.
 */
const RETRY_DELAYS_MS = [400, 800];

const wait = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const ensureSessionAfterVerification = async (
  email: string,
  password: string,
) => {
  try {
    const { data } = await supabase.auth.refreshSession();
    if (data.session?.user) return data.session;
  } catch {
    // negeren: we proberen hieronder alsnog in te loggen
  }

  const cleanEmail = normalizeEmail(email);
  if (!cleanEmail || !password) return null;

  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
    try {
      const { data } = await supabase.auth.signInWithPassword({
        email: cleanEmail,
        password,
      });
      if (data?.session?.user) return data.session;
    } catch {
      // netwerkfout: opnieuw proberen
    }
    if (attempt < RETRY_DELAYS_MS.length) await wait(RETRY_DELAYS_MS[attempt]);
  }
  return null;
};
